import {TreatmentModel} from "../../features/home/components/treatment-management/treatment.types";
import {User} from "../types/smm/smm-person.types";
import {Activity} from "../../features/patient/patient-profile/patient-profile.component";
import {ICard} from "../../features/patient/interventions/intervention.types";
import {Tenant} from "../../features/home/components/dash-boards/platform-owner-dash/types/platform.owner.types";

export function prepareStrForCompare(strToPrepare:string){
    if(!strToPrepare){
        return "";
    }

    const str = strToPrepare + "";

    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function strPassesFilter(str:string, filter:string):boolean{
    if(!filter){
        return true;
    }
    if(!str){
        return false;
    }

    const strClean = prepareStrForCompare(str);
    const filterClean = prepareStrForCompare(filter);

    const searchTokens:string[] = filterClean.split(/\s+/);
    const sizeBefore = searchTokens.length;
    const sizeAfter = searchTokens.filter(token => strClean.includes(token)).length;

    //means that every keyword is included by string
    return sizeBefore == sizeAfter;
}

export function treatmentModelPassesFilter(tr:TreatmentModel, filterTxt:string):boolean{
    if(!tr || !filterTxt || filterTxt.length == 0){
        return true;
    }
    const summaryPasses: boolean = strPassesFilter(tr?.getSummary(), filterTxt);
    const codePasses: boolean = strPassesFilter(tr?.getProductCode(), filterTxt);
    const descriptionPasses: boolean = strPassesFilter(tr?.getDescription(), filterTxt);
    return summaryPasses || codePasses || descriptionPasses;
}

export function userPassesFilter(user: User, filterTxt:string): boolean{
    if(!user || !filterTxt || filterTxt.length == 0){
        return true;
    }
    const name = user?.firstName + " " + user?.lastName;
    const namePasses: boolean = strPassesFilter(name, filterTxt);
    const phonePasses: boolean = strPassesFilter(user?.phoneNumber, filterTxt);
    return namePasses || phonePasses;
}

export function cardPassesFilter(card: ICard, filterTxt:string): boolean{
    if(!card || !filterTxt || filterTxt.length == 0){
        return true;
    }
    const titlePasses: boolean = strPassesFilter(card?.title, filterTxt);
    const subtitlePasses: boolean = strPassesFilter(card?.subtitle, filterTxt);
    const descriptionPasses: boolean = strPassesFilter(card?.description, filterTxt);
    return titlePasses || subtitlePasses || descriptionPasses;
}

export function activityPassesFilter(activity: Activity, filterTxt:string): boolean{
    if(!activity || !filterTxt || filterTxt.length == 0){
        return true;
    }
    const treatmentPasses: boolean = activity.treatments.filter(
        (treatment) => treatmentModelPassesFilter(treatment, filterTxt))?.length > 0;
    const conditionPassesFilter: boolean = treatmentModelPassesFilter(activity.condition.getCondition(), filterTxt) || strPassesFilter(activity.location, filterTxt); //tooth ID filter
    return treatmentPasses || conditionPassesFilter;
}

export function tenantPassesFilter(tenant: Tenant, filterTxt: string): boolean {
    if (!tenant || !filterTxt || filterTxt.length == 0) {
        return true;
    }

    const tenantIdPasses: boolean = strPassesFilter(tenant.tenantId, filterTxt);

    const masterDataPasses: boolean = !!tenant.masterData && (
        strPassesFilter(tenant.masterData.id, filterTxt) ||
        strPassesFilter(tenant.masterData.tenantId, filterTxt) ||
        strPassesFilter(tenant.masterData.tenantName, filterTxt) ||
        strPassesFilter(tenant.masterData.tenantStatus, filterTxt)
    );

    const signUpRequestPasses: boolean = !!tenant.signUpRequest && (
        strPassesFilter(tenant.signUpRequest.id, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.name, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.phoneNumber, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.email, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.address, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.cui, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.companyName, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.commerceRegisterId, filterTxt) ||
        strPassesFilter(tenant.signUpRequest.status, filterTxt)
    );

    let countStatsPasses = false;
    if (tenant.countStats) {
        const stats = tenant.countStats;
        const tenantIdStatPasses = strPassesFilter(stats.tenantId, filterTxt);
        const dateStatPasses = strPassesFilter(stats.dateOfUpdate, filterTxt);
        let roleStatsPasses = false;
        if (stats.userCountPerRoleMap) {
            roleStatsPasses = Object.entries(stats.userCountPerRoleMap).some(([role, count]) =>
                strPassesFilter(role, filterTxt) || strPassesFilter(count?.toString(), filterTxt)
            );
        }
        countStatsPasses = tenantIdStatPasses || dateStatPasses || roleStatsPasses;
    }

    return tenantIdPasses || masterDataPasses || signUpRequestPasses || countStatsPasses;
}
